class PremiumProductBenefits extends HTMLElement {
  connectedCallback() {
    this.classList.add('is-reveal-ready');
    this.visual = this.querySelector('[data-ppb-visual]');
    this.visualStage = this.visual?.querySelector('.ppb__visual-stage');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.desktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    this.addEventListener('pointerdown', this.onPointerDown);
    this.visual?.addEventListener('pointermove', this.onVisualPointerMove);
    this.visual?.addEventListener('pointerleave', this.resetVisualTilt);
    this.setupReveal();
  }

  disconnectedCallback() {
    this.removeEventListener('pointerdown', this.onPointerDown);
    this.visual?.removeEventListener('pointermove', this.onVisualPointerMove);
    this.visual?.removeEventListener('pointerleave', this.resetVisualTilt);
    this.observer?.disconnect();
    cancelAnimationFrame(this.tiltFrame);
    clearTimeout(this.clickTimer);
  }

  onPointerDown = (event) => {
    const card = event.target.closest('[data-ppb-card]');
    if (card && this.contains(card)) {
      this.animateCard(card, event);
      return;
    }

    const visual = event.target.closest('[data-ppb-visual]');
    if (!visual || !this.contains(visual)) return;
    visual.classList.remove('is-clicked');
    requestAnimationFrame(() => visual.classList.add('is-clicked'));
    clearTimeout(this.clickTimer);
    this.clickTimer = setTimeout(() => visual.classList.remove('is-clicked'), 560);
  };

  animateCard(card, event) {
    card.classList.remove('is-clicked');
    requestAnimationFrame(() => card.classList.add('is-clicked'));
    setTimeout(() => card.classList.remove('is-clicked'), 500);

    const ripple = card.querySelector('[data-ppb-ripple]');
    if (!ripple || this.reducedMotion.matches) return;
    const rect = card.getBoundingClientRect();
    ripple.style.left = `${event.clientX - rect.left}px`;
    ripple.style.top = `${event.clientY - rect.top}px`;
    ripple.classList.remove('is-active');
    requestAnimationFrame(() => ripple.classList.add('is-active'));
    ripple.addEventListener('animationend', () => ripple.classList.remove('is-active'), { once: true });
  }

  onVisualPointerMove = (event) => {
    if (
      this.dataset.enableTilt !== 'true' ||
      this.reducedMotion.matches ||
      !this.desktopPointer.matches ||
      !this.visualStage
    ) return;

    const rect = this.visual.getBoundingClientRect();
    const horizontal = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
    const vertical = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
    cancelAnimationFrame(this.tiltFrame);
    this.tiltFrame = requestAnimationFrame(() => {
      this.visualStage.style.setProperty('--ppb-tilt-x', `${horizontal * 2.5}deg`);
      this.visualStage.style.setProperty('--ppb-tilt-y', `${vertical * -2.5}deg`);
    });
  };

  resetVisualTilt = () => {
    if (!this.visualStage) return;
    this.visualStage.style.setProperty('--ppb-tilt-x', '0deg');
    this.visualStage.style.setProperty('--ppb-tilt-y', '0deg');
  };

  setupReveal() {
    if (!('IntersectionObserver' in window)) {
      this.classList.add('is-revealed', 'is-in-view');
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.classList.toggle('is-in-view', entry.isIntersecting);
        if (entry.isIntersecting) this.classList.add('is-revealed');
      },
      { rootMargin: '120px 0px', threshold: 0.06 }
    );
    this.observer.observe(this);
  }
}

if (!customElements.get('premium-product-benefits')) {
  customElements.define('premium-product-benefits', PremiumProductBenefits);
}
